var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLastRun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.58331 0.75C4.68415 0.75 2.33331 3.10083 2.33331 6H0.583313L2.85248 8.26917L2.89331 8.35083L5.24998 6H3.49998C3.49998 3.7425 5.32581 1.91667 7.58331 1.91667C9.84081 1.91667 11.6666 3.7425 11.6666 6C11.6666 8.2575 9.84081 10.0833 7.58331 10.0833C6.45748 10.0833 5.43665 9.6225 4.70165 8.88167L3.87331 9.71C4.82415 10.6608 6.13081 11.25 7.58331 11.25C10.4825 11.25 12.8333 8.89917 12.8333 6C12.8333 3.10083 10.4825 0.75 7.58331 0.75ZM6.99998 3.66667V6.58333L9.47915 8.05333L9.92831 7.30667L7.87498 6.0875V3.66667H6.99998Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLastRun);
export default __webpack_public_path__ + "static/media/last-run.7ec0719f8504f276fa9124fa50833c77.svg";
export { ForwardRef as ReactComponent };